import Component from '../core/Component'
import $ from 'jquery'
import { loadComponents } from '../core/componentUtils'
import { scrollToElement } from '../services/Scroll'

export const STATES = {
    WORKING: 'is-working'
}

export default class CardList extends Component {

    constructor(element) {
        super(element)

        this.ref = {
            list: null,
            loadMore: null
        }

        this.inProgress = false
    }

    prepare() {
        this.ref.loadMore.addEventListener('click', ::this.handleLoadMore)
    }

    handleLoadMore(event) {
        event.preventDefault()

        if (this.inProgress) {
            return
        }

        const trigger = event.target.closest('a')

        if (!trigger) {
            return
        }

        const button = event.target.closest('.Button')

        this.inProgress = true

        if (button) {
            button.classList.add(STATES.WORKING)
        }

        $.ajax({
            url: trigger.href,
            success: response => {
                this.inProgress = false
                this.handleResponse(response)
            }
        })
    }

    handleResponse(response) {
        const { snippets } = response
        const items = snippets['snippet--items']
        const paginator = snippets['snippet--paginator']

        const fragment = document.createDocumentFragment()
        const buffer = document.createElement('div')
        buffer.innerHTML = items

        const elements = [...buffer.children]
        elements
            .forEach(element => {
                element.classList.add('is-hidden')
                element.classList.add('is-animated')
                fragment.appendChild(element)
            })

        this.ref.list.appendChild(fragment)
        elements.forEach(element => loadComponents(element))
        elements.forEach((element, index) => {
            setTimeout(() => {
                element.classList.remove('is-hidden')
            }, index * 100)
        })
        document.getElementById('snippet--paginator').innerHTML = paginator
        scrollToElement(elements[0])
    }

}